import { PATH } from '@/enum'
import {
  Gpu,
  Apply,
  Account,
  Desktop,
  EBusiness,
  Generic,
  Gpus,
  Disk,
  Bill,
  Apps,
  CouponPackage,
  Deposit,
  Diffusion,
  Train,
  Deduction,
  Computer,
  ComputerCombo,
  ModelSquare,
  ModelDetail,
  ModelExperience,
  ModelStats,
  ModelKey,
  // ModelTokens,
  ResourceBundle,
  ImageGenerator,
  VideoGenerator,
  Purchase,
  ModelCost,
} from '../components'

import { Scenes } from '@/enum'

export const menus = [
  {
    path: PATH.GPU,
    component: Gpu,
    key: 'Gpu2',
    title: '算力市场',
    icon: 'computMarketIcon',
    name: PATH.GPU,
    meta: {
      belong: 'gpu',
    },
  },
  {
    path: PATH.APPLY,
    component: Apply,
    key: 'Apply',
    title: '镜像应用',
    icon: 'imageAppIcon',
    name: PATH.APPLY,
    meta: {
      belong: 'gpu',
    },
  },
  {
    path: '',
    key: 'compute',
    title: '资源管理',
    meta: {
      lastRootItem: true,
    },
    children: [
      {
        path: PATH.GPU_GENERIC,
        component: Gpus,
        key: 'Gpu',
        title: 'GPU 实例',
        icon: 'cpuIcon',
        name: PATH.GPU_GENERIC,
        meta: {
          requireAuth: true,
          belong: 'gpu',
        },
      },
      {
        path: PATH.GPU_APPLICATION,
        component: Apps,
        key: 'App',
        title: '应用实例',
        icon: 'instanceIcon',
        name: PATH.GPU_APPLICATION,
        meta: {
          requireAuth: true,
          belong: 'gpu',
        },
      },
      {
        path: PATH.DATA_DISK,
        component: Disk,
        key: 'disk',
        title: '我的数据',
        icon: 'dataIcon',
        name: PATH.DATA_DISK,
        meta: {
          requireAuth: true,
          belong: 'gpu',
        },
      },
    ],
  },
]
export const generic = [
  {
    path: PATH.APPARATUS_GENERIC,
    component: Generic,
    key: 'Generic',
    title: '云主机',
    icon: 'generic',
    meta: {
      requireAuth: true,
    },
  },
  // {
  //   path: PATH.APPARATUS_GAME,
  //   component: Games,
  //   key: 'Game',
  //   title: '云游戏',
  //   icon: 'game',
  //   meta: {
  //     requireAuth: true,
  //   },
  // },

  {
    path: PATH.APPARATUS_DESKTOP,
    component: Desktop,
    key: 'Desktop',
    title: '云桌面',
    icon: 'desktop',
    meta: {
      requireAuth: true,
    },
  },
  {
    path: PATH.APPARATUS_E_BUSINESS,
    component: EBusiness,
    key: 'E-business',
    title: '跨境电商',
    icon: 'ebusiness',
    meta: {
      requireAuth: true,
    },
  },
]
export const center = [
  {
    path: PATH.COST,
    key: 'cost',
    title: '费用中心',
    icon: 'cost',
    redirect: PATH.COST_DEPOSIT,
    children: [
      {
        path: PATH.COST_DEPOSIT,
        component: Deposit,
        key: 'deposit',
        title: '我的余额',
        meta: {
          requireAuth: true,
        },
      },
      {
        path: PATH.COST_BILL,
        component: Bill,
        key: 'bill',
        title: '账单',
        meta: {
          requireAuth: true,
        },
      },

      {
        path: PATH.COST_COUPON_PACKAGE,
        component: CouponPackage,
        key: 'couponPackage',
        title: '券包',
        meta: {
          requireAuth: true,
        },
      },
      // {
      //   path: PATH.COST_RESOURCE,
      //   component: ResourceBundle,
      //   key: 'resource',
      //   title: '资源包',
      //   meta: {
      //     requireAuth: true,
      //   },
      // },
    ],
  },
  {
    path: `${PATH.ACCOUNT}`,
    component: Account,
    key: 'account',
    title: '个人中心',
    meta: {
      requireAuth: true,
    },
  },
]

export const clouds = [
  // {
  //   path: PATH.GPU,
  //   component: Gpu,
  //   key: 'gpu',
  //   title: 'GPU 实例',
  //   name: PATH.GPU,
  //   // meta: {
  //   //   requireAuth: true,
  //   // },
  // },
  // {
  //     path: PATH.APPLY,
  //       component: Apply,
  //       key: 'apply',
  //       title: '镜像应用',
  //       name: PATH.APPLY,
  // },
]
export const ai: any = [
  {
    path: PATH.TRAIN,
    component: Train,
    key: 'train',
    title: 'LoRA 训练',
    icon: 'train',
    meta: {
      requireAuth: true,
    },
  },
  {
    path: PATH.DIFFUSION,
    component: Diffusion,
    key: 'diffusion',
    title: 'LoRA 生图',
    icon: 'diffusion',
    meta: {
      requireAuth: true,
    },
  },
  {
    path: PATH.DATA_SET,
    component: Deduction,
    key: 'deduction',
    title: '数据集',
    icon: 'deduction',
    meta: {
      requireAuth: true,
    },
  },
  {
    path: PATH.COMPUTE,
    key: 'compute',
    title: '算力中心',
    icon: 'compute',
    children: [
      {
        path: PATH.COMPUTE_CENTER,
        component: Computer,
        name: PATH.COMPUTE_CENTER,
        title: '我的算力',
        meta: {
          requireAuth: true,
        },
      },
      {
        path: PATH.COMPUTER_COMBO,
        component: ComputerCombo,
        name: PATH.COMPUTER_COMBO,
        title: '算力商城',
        meta: {
          requireAuth: true,
        },
      },
    ],
  },
]

export const cloudHost = [
  {
    path: `${PATH.PURCHASE}?scene=${Scenes.Generic}`,
    component: Purchase,
    key: 'cloudHost',
    title: '云主机',
    icon: 'generic',
    name: `${PATH.PURCHASE}?scene=${Scenes.Generic}`,
  },
  {
    path: `${PATH.PURCHASE}?scene=${Scenes.Desktop}`,
    component: Purchase,
    key: 'cloudDesktop',
    title: '云桌面',
    icon: 'desktop',
    name: `${PATH.PURCHASE}?scene=${Scenes.Desktop}`,
  },
  {
    path: `${PATH.PURCHASE}?scene=${Scenes.Ebusiness}`,
    component: Purchase,
    key: 'cloudEbusiness',
    title: '跨境电商',
    icon: 'ebusiness',
    name: `${PATH.PURCHASE}?scene=${Scenes.Ebusiness}`,
  },
  {
    path: '',
    key: 'management',
    title: '资源管理',
    meta: {
      lastRootItem: true,
    },
    children: [
      {
        path: PATH.GENERIC,
        component: Gpus,
        key: 'cpum',
        title: 'CPU 实例',
        icon: 'cpuInstanceIcon',
        name: PATH.GENERIC,
      },
    ],
  },
]

export const models = [
  {
    path: PATH.MODEL_SQUARE,
    component: ModelSquare,
    key: 'square',
    title: '模型广场',
    icon: 'modelSquareIcon',
    name: PATH.MODEL_SQUARE,
  },

  {
    path: PATH.MODEL_SQUARE_DETAIL,
    component: ModelDetail,
    key: 'modelDetail',
    title: '模型详情',
    icon: '',
    name: 'model-detail',
    meta: {
      hideInMenu: true, // 在菜单中隐藏
      activeMenu: PATH.MODEL_SQUARE, // 激活模型广场菜单
    },
  },
  {
    path: '',
    // component: ModelExperience,
    key: 'experience',
    title: '在线体验',
    icon: 'modelExperienceIcon',
    name: PATH.MODEL_EXPERIENCE,
    children: [
      {
        path: PATH.MODEL_EXPERIENCE,
        component: ModelExperience,
        key: 'text',
        title: '文本生成',
        icon: 'modelChatIcon',
        name: PATH.MODEL_EXPERIENCE,
      },
      // {
      //   path: PATH.MODEL_IMAGE_GENERATOR,
      //   component: ImageGenerator,
      //   key: 'image',
      //   title: '图片生成',
      //   name: PATH.MODEL_IMAGE_GENERATOR,
      // },
      // {
      //   path: PATH.MODEL_VIDEO_GENERATOR,
      //   component: VideoGenerator,
      //   key: 'video',
      //   title: '视频生成',
      //   name: PATH.MODEL_VIDEO_GENERATOR,
      // },
    ],
  },
  {
    path: '',
    // component: ModelExperience,
    key: 'system',
    title: '系统管理',
    icon: 'modelExperienceIcon',
    name: PATH.MODEL_COST,
    meta: {
      lastRootItem: true,
    },
    children: [
      {
        path: PATH.MODEL_COST,
        component: ModelCost,
        key: 'cost',
        title: '费用统计',
        icon: 'modelCostIcon',
        name: PATH.MODEL_COST,
      },
      {
        path: PATH.MODEL_STATS,
        component: ModelStats,
        key: 'stats',
        title: '用量统计',
        icon: 'modelStatsIcon',
        name: PATH.MODEL_STATS,
      },
      {
        path: PATH.MODEL_KEY,
        component: ModelKey,
        key: 'key',
        title: 'API KEY',
        icon: 'modelKeyIcon',
        name: PATH.MODEL_KEY,
      },
    ],
  },
  // {
  //   path: PATH.MODEL_TOKENS,
  //   component: ModelTokens,
  //   key: 'tokens',
  //   title: 'Tokens 管理',
  //   icon: 'tokensIcon',
  //   name: PATH.MODEL_TOKENS,
  //   meta: {
  //     requireAuth: true,
  //   },
  // },
]
